module.exports = __webpack_public_path__ + "static/8-bde99287fe27e0e3ee89058a0affd4cd.woff";